var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy, faExchangeAlt, faEye, faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BBadge, BButton, BButtonGroup } from "bootstrap-vue";
import { computed } from "vue";
import localize from "@/utils/localization";
import ExportRecordDOILink from "@/components/Common/ExportRecordDOILink.vue";
import Heading from "@/components/Common/Heading.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ArchivedHistoryCard',
    props: {
        history: null
    },
    emits: ["onView", "onSwitch", "onRestore", "onImportCopy"],
    setup(__props, { emit }) {
        const props = __props;
        const canImportCopy = computed(() => { var _a; return ((_a = props.history.export_record_data) === null || _a === void 0 ? void 0 : _a.target_uri) !== undefined; });
        library.add(faExchangeAlt, faUndo, faCopy, faEye);
        function onViewHistoryInCenterPanel() {
            emit("onView", props.history);
        }
        function onSetAsCurrentHistory() {
            emit("onSwitch", props.history);
        }
        function onRestoreHistory() {
            return __awaiter(this, void 0, void 0, function* () {
                emit("onRestore", props.history);
            });
        }
        function onImportCopy() {
            return __awaiter(this, void 0, void 0, function* () {
                emit("onImportCopy", props.history);
            });
        }
        return { __sfc: true, props, canImportCopy, emit, onViewHistoryInCenterPanel, onSetAsCurrentHistory, onRestoreHistory, onImportCopy, faCopy, faExchangeAlt, faEye, faUndo, FontAwesomeIcon, BBadge, BButton, BButtonGroup, localize, ExportRecordDOILink, Heading, StatelessTags, UtcDate };
    }
});
